import {extendTheme, type ThemeConfig} from "@chakra-ui/react";

const config: ThemeConfig = {
    initialColorMode: "dark",
    useSystemColorMode: false,
};

const theme = extendTheme({ 
    fonts: {
        heading: `Kanit, monospace`,
        body: `Kanit, monospace`,
    }, 
    config 
});

export default theme;